import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Department, IdNameVM, ObservationDetailsDomain, SiteCodes, WorkAreasByDepartmentVM } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { SafetyGeneraldashboardService } from '../services/safety-generaldashboard.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-enter-safety-inspection-dialog',
  templateUrl: './enter-safety-inspection-dialog.component.html',
  styleUrls: ['./enter-safety-inspection-dialog.component.css']
})
export class EnterSafetyInspectionDialogComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<EnterSafetyInspectionDialogComponent>,
    private _safetyConfigService:SafetyConfigService,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  inputValuestate:number
  siteCodesList: SiteCodes[]=[];
  departmentlist:Department[];
  departmentlist_:Department[];
 
  Filteredworklist:WorkAreasByDepartmentVM[]=[];
  WorkList:IdNameVM[]=[];
  Allworklist:WorkAreasByDepartmentVM[]=[];
  inputValueDepartment:number
  inputValueTaskObserved
  inputValueWorkArea
  observationDate;
  inspectionID:ObservationDetailsDomain

  ngOnInit() {
    
    this. loadSiteList();
    this.getdepartmentlist();
    this.getAllWorkAreas();
  }

  DialogClose(){
    this.dialogRef.close(false)
  }

  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }

  loadSiteList()
  {
    this._safetyConfigService.getAllSitesList().subscribe(sites =>
    { 
      console.log('sitelist',sites)
      this.siteCodesList=sites;
      
    });
  }

  getdepartmentlist(){
    this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
    
    this.departmentlist=res.Departments;
    //this.worklist=res.WorkAreas;
    console.log( "departments",this.departmentlist)

   
    })
  }

  stateChanged(event:any)
  {
    let value=event.value
    this._safetyConfigService.GetDepartmentsAndWorkAreas().subscribe(res=>{ 
    
      this.departmentlist=res.Departments;
     
      this.departmentlist_  =  this.departmentlist.filter(x=>x.SiteId == value);
  
     
      })
  }


  getAllWorkAreas(){
    this._safetyGeneraldashboardService.GetActiveWorkAreasForDropDownList().subscribe(res =>
      {
        console.log("workareas", res)
      
        this.Allworklist = res;
       
      });
  }

  GetActiveWorkAreasForDropDownListChanged()
  {
    if(this.Allworklist.length>0){
      this.Filteredworklist  =  this.Allworklist.filter(x=>x.DepartmentId == this.inputValueDepartment);
      let temp  =  this.Filteredworklist[0].WorkAreas;

      let state = this.siteCodesList.find(f=>f.Id==this.inputValuestate);
      let wrk = temp.length >0 ? this.WorkList.filter(c=>c.Name.includes(state.SiteName)): temp;
   
      this.WorkList = wrk != null && wrk.length>0 ? wrk : temp
      console.log("department ID",this.inputValueDepartment)
      console.log("work list per department", this.Filteredworklist)
    }
  }

  CreateNewInspection()
  {
    let model = new ObservationDetailsDomain()
    model.ObservationDate=this.observationDate
    model.WorkAreaID=this.inputValueWorkArea
    model.TaskObserved=this.inputValueTaskObserved
    model.SiteId=this.inputValuestate
    this._safetyGeneraldashboardService.CreateNewInspection(model).subscribe(res=>
      {
        console.log(res)
        if(res>0){
          //this.router.navigateByUrl('Inspection/Index',res);
          this.router.navigate(['/inspection/index', res]);
          this.DialogClose();
        }
        
      });

      
     
  }

}
